import BNutritionFirstBlock from './BNutritionFirstBlock'

export default BNutritionFirstBlock
